interface Props {
  color: string;
}

export const MarkerCell = ({ color }: Props) => {
  return (
    <div className="relative -mx-4 -my-[14px] flex h-full items-center px-4">
      <div className="absolute left-0 top-0 h-full w-1" style={{ backgroundColor: color }} />
    </div>
  );
};
